<app-navbar *ngIf="currentUser"
  [currentUser]="currentUser"
  [screenAccessSet]="screenAccessSet"
  [userName]="userName"
></app-navbar>

<!-- main app container -->
<div class="background">
  <div class="bottom">
    <app-notification></app-notification>
  </div>
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</div>

<app-loader *ngIf="fetchData"></app-loader>
